import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';
import DevicesTable from '../components/tables/home-page/DevicesTable';
import { FileDropzone } from '../components/Inputs';
import ErrorTable from '../components/tables/home-page/ErrorTable';
import { FaBell } from 'react-icons/fa';

function Home() {
  const { uploadAuthenticatedFile, sendAuthenticatedRequest } = useAuth();
  const [devices, setDevices] = useState([]);
  const [unreadUrgentCount, setUnreadUrgentCount] = useState(0);

  const fetchDevices = async () => {
    try {
      const resp = await sendAuthenticatedRequest('/devices', 'GET');
      if (!resp.error) {
        setDevices(resp);
        console.log(devices);
      } else {
        toast.error('Failed to fetch devices');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong fetching devices');
    }
  };

  const fetchUnreadUrgentCount = async () => {
    try {
      const resp = await sendAuthenticatedRequest(
        '/urgent/alerts/unread-count',
        'GET'
      );
      if (resp && typeof resp.count === 'number') {
        setUnreadUrgentCount(resp.count);
      }
    } catch (e) {
      // Silently ignore; bell will just appear gray
      console.error(e);
    }
  };

  useEffect(() => {
    fetchDevices();
    fetchUnreadUrgentCount();
    const id = setInterval(fetchUnreadUrgentCount, 60000);
    return () => clearInterval(id);
  }, []);

  const handleUploadUpdateFile = async (file) => {
    try {
      const resp = await uploadAuthenticatedFile(`/files`, file);
      if (!resp.error) {
        toast.success('Uploaded file successfully!');
      } else {
        toast.error('Something went wrong uploading the file');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong uploading the file');
    }
  };

  return (
    <div className="p-6 space-y-6 bg-background min-h-screen">
      <div className="flex justify-end">
        <a
          href="/alerts/urgent"
          className="relative inline-block"
          aria-label="View urgent alerts"
        >
          <FaBell
            size={28}
            color={unreadUrgentCount > 0 ? '#0d6efd' : '#6c757d'}
            aria-hidden="true"
          />

          {/* Red badge when there are unread alerts */}
          {unreadUrgentCount > 0 && (
            <span
              className="absolute -top-1.5 -right-2 bg-red-600 text-white rounded-full min-w-[18px] h-[18px] px-[5px] text-[12px] leading-[18px] text-center font-semibold"
              aria-live="polite"
            >
              {unreadUrgentCount}
            </span>
          )}
        </a>
      </div>

      <FileDropzone onChange={handleUploadUpdateFile} />
      <DevicesTable devices={devices} />
      <ErrorTable />
    </div>
  );
}

export default Home;
